<div class="Privay-policy mt5">
  <div class="container">
    <div class="row">
      <div class="offset-md-2 col-lg-8">
        <h3>Mentoga's Privacy Policy</h3>
        <p class="gilroy mt-3">
          Welcome to Mentoga’s Privacy Policy (“Policy”). This document outlines how Mentoga
          (“Mentoga,” “we,” “our,” or “us”) collects, uses, stores, and protects personal information. By
          accessing or using Mentoga’s website at www.Mentoga.com or any related services,
          applications, or platforms operated by Mentoga (collectively referred to as the “Site”), you
          agree to the terms described in this Policy. If you do not agree, please discontinue using our
          Site.
          Mentoga is committed to maintaining the privacy and security of your personal information.
          This Policy may be updated periodically, and any changes will be posted on this page with
          the "Last Updated" date. Significant changes may also be communicated through
          notifications or emails, where required by law.
        </p>
        <h5>Table Of Contents</h5>
        <ol class="gilroy">
          <li>Information We Collect</li>
          <li>Legal Basis for Processing Personal Information</li>
          <li>How We Use Your Information</li>
          <li>Retention of Personal Information</li>
          <li>Policy for Minors</li>
          <li>Child Protection Policy</li>
          <li>Sharing Personal Information with Third Parties</li>
          <li>Storage and Transfer of Personal Information</li>
          <li>Cookies and Tracking Technologies</li>
          <li>Do Not Track (DNT) Compliance</li>
          <li>External Links</li>
          <li>Data Security</li>
          <li>Your Privacy Rights (EU, EEA, UK)</li>
          <li>Specific Provisions for California Residents</li>
          <li>Updating and Correcting Personal Information</li>
          <li>SMS Privacy Policy</li>
          <li>Contact Us</li>
        </ol>

        <h5 class="text-col-pri">1. Information We Collect</h5>
        <p class="gilroy">
          Mentoga collects personal information directly from users, automatically through usage of
          the Site, and from third-party sources. The categories of data collected include:
        </p>
        <h6>1.1 Information You Provide</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              <strong>Account Information: </strong>
              Name, email address, username, password, and other details
              you provide when registering.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Profile Information: </strong>
              Photos, biographies, and any other content you upload.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Communication: </strong>
              Messages, comments, and interactions with Mentoga or other
              users on the platform.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Forms and Surveys: </strong>
              Responses to forms, questionnaires, or surveys.
            </p>
          </li>
        </ul>
        <h6>1.2 Information Collected Automatically</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              <strong>Usage Data: </strong>
              IP addresses, browser types, operating systems, pages visited, and
              time spent on the Site.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Device Information: </strong>
              Device type, operating system, and geographic location.
            </p>
          </li>
        </ul>
        <h6>1.3 Information from Third Parties</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              <strong>Linked Accounts: </strong>
              Data from accounts connected to Mentoga (e.g., social media
              platforms).
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Analytics Providers: </strong>
              Data on how users interact with the Site.
            </p>
          </li>
        </ul>

        <h5 class="text-col-pri">2. Legal Basis for Processing Personal Information</h5>
        <p class="gilroy">
          We process personal information in accordance with applicable laws and under the following
          legal bases:
        </p>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              <strong>Consent: </strong>
              When you provide explicit consent for specific purposes, such as receiving
              marketing communications.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Contractual Necessity: </strong>
              To fulfil obligations under contracts, including providing
              requested services.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Legal Obligations: </strong>
              To comply with regulatory or legal requirements, such as fraud
              prevention.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Legitimate Interests: </strong>
              To improve our services, enhance security, and conduct
              business operations without infringing on your rights.
            </p>
          </li>
        </ul>

        <h5 class="text-col-pri">3. How We Use Your Information</h5>
        <p class="gilroy">
          Mentoga uses your personal information for the following purposes:
        </p>
        <h6>3.1 Service Delivery</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Set up, verify, and manage user accounts.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Provide customer support and technical assistance.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Enable secure communication between users.
            </p>
          </li>
        </ul>
        <h6>3.2 Site Improvement</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Analyse user behaviour to optimise features and functionality.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Personalise user experiences, including tailored recommendations.
            </p>
          </li>
        </ul>
        <h6>3.3 Communication</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Notify users about updates, new features, or policy changes.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Respond to user inquiries or complaints.
            </p>
          </li>
        </ul>
        <h6>3.4 Marketing and Promotions</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Send promotional content tailored to user preferences.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Facilitate referral programs, contests, and other events.
            </p>
          </li>
        </ul>
        <h6>3.5 Compliance and Security</h6>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Detect and prevent fraudulent activities.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Ensure compliance with legal and regulatory obligations.
            </p>
          </li>
        </ul>

        <h5 class="text-col-pri">4. Retention of Personal Information</h5>
        <p class="gilroy">
          We retain personal information as long as necessary to fulfil the purposes outlined in this
          Policy, including:
        </p>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Maintaining accurate records of transactions and user activity.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Complying with legal and regulatory requirements.
            </p>
          </li>
        </ul>
        <p class="gilroy">
          Data may be retained longer for dispute resolution, fraud prevention, or enforcement of our
          Terms of Service.
        </p>

        <h5 class="text-col-pri">5. Policy for Minors</h5>
        <p class="gilroy">
          Mentoga’s Site is designed for users who are:
        </p>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              <strong>18 years or older</strong>
              , or
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>13–17 years old with parental or guardian consent.</strong>
            </p>
          </li>
        </ul>
        <p class="gilroy">
          We do not knowingly collect data from children under 13. If we become aware of such data
          collection, we will delete the information immediately. Parents or guardians should supervise
          minors’ activities on the Site.
        </p>

        <h5 class="text-col-pri">6. Child Protection Policy</h5>
        <p class="gilroy">
          At Mentoga, we prioritize the privacy and safety of children using our app. We comply with applicable child protection laws, including COPPA, GDPR for children, and Google Play's Families Policy.
        </p>
        <h6>6.1 Data Collection</h6>
        <p class="gilroy">We do not collect personal data from children without verifiable parental consent. Any data collected is limited to what is necessary for the app’s functionality.</p>
        <h6>6.2 Advertisements</h6>
        <p class="gilroy">
          Ads shown to children are family-friendly and comply with child-directed service standards. No personalized ads are shown to users under 13.
        </p>
        <h6>6.3 Safety Measures</h6>
        <p class="gilroy">
          Our app prevents inappropriate content, restricts unauthorized purchases, and avoids exposing children to risks through chat or social features.
        </p>
        <h6>6.4 Parental Controls</h6>
        <p class="gilroy">
          Parents have tools to manage their child’s usage, including restricting features and monitoring access.
        </p>
        <h6>6.5 Third-Party Services</h6>
        <p class="gilroy">
          All integrated services comply with child protection laws and do not misuse data.
        </p>
        <h6>6.6 Reporting</h6>
        <p class="gilroy">
          For concerns about privacy or inappropriate content, contact us at <strong>contact&#64;mentoga.com</strong>.
        </p>
        <p class="gilroy">
          We are committed to updating our practices as regulations evolve to ensure children’s safety and privacy.
        </p>

        <h5 class="text-col-pri">7. Sharing Personal Information with Third Parties</h5>
        <p class="gilroy">
          We may share your information in the following ways:
        </p>
        <h6>7.1 With Service Providers</h6>
        <p class="gilroy">Third parties assisting with:</p>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Hosting, analytics, and marketing services.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Payment processing and fraud detection.
            </p>
          </li>
        </ul>
        <h6>7.2 For Legal Compliance</h6>
        <p class="gilroy">
          To comply with subpoenas, court orders, or regulatory requirements.
        </p>
        <h6>7.3 Other Users</h6>
        <p class="gilroy">
          Limited profile details (e.g., username) may be visible during user interactions.
        </p>
        <h6>7.4 Corporate Transactions</h6>
        <p class="gilroy">
          In the event of a merger, acquisition, or sale of assets, personal data may be transferred to
          the acquiring entity.
        </p>

        <h5 class="text-col-pri">8. Storage and Transfer of Personal Information</h5>
        <h6>8.1 Storage Locations</h6>
        <p class="gilroy">
          Personal information may be stored in the United States or other jurisdictions with adequate
          data protection laws.
        </p>
        <h6>8.2 Cross-Border Transfers</h6>
        <p class="gilroy">
          For transfers outside the European Economic Area (EEA), we implement safeguards, such
          as Standard Contractual Clauses.
        </p>

        <h5 class="text-col-pri">9. Cookies and Tracking Technologies</h5>
        <p class="gilroy">
          Mentoga does not currently use cookies. If introduced in the future, cookies will be used to:
        </p>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              Enhance user experience.
            </p>
          </li>
          <li>
            <p class="gilroy">
              Analyse website performance.
            </p>
          </li>
        </ul>

        <h5 class="text-col-pri">10. Do Not Track (DNT) Compliance</h5>
        <p class="gilroy">
          The Site does not respond to Do Not Track signals sent by browsers.
        </p>

        <h5 class="text-col-pri">11. External Links</h5>
        <p class="gilroy">
          Mentoga’s Site may include links to third-party websites. We are not responsible for the
          privacy practices or content of these sites and recommend reviewing their privacy policies.
        </p>

        <h5 class="text-col-pri">12. Data Security</h5>
        <h6>12.1 Security Measures</h6>
        <p class="gilroy">
          We use industry-standard measures, including encryption, to protect personal information.
        </p>
        <h6>12.2 User Responsibility</h6>
        <p class="gilroy">
          Users are responsible for maintaining strong, confidential passwords.
        </p>

        <h5 class="text-col-pri">13. Your Privacy Rights (EU, EEA, UK)</h5>
        <p class="gilroy">
          If you reside in the EU, EEA, or UK, you have specific rights under GDPR, including:
        </p>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              <strong>Access and Rectification: </strong>
              View and correct your personal data.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Erasure: </strong>
              Request deletion of personal data in certain circumstances.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Restriction: </strong>
              Limit processing of personal data.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Portability: </strong>
              Request a machine-readable copy of your data.
            </p>
          </li>
        </ul>
        <p class="gilroy">
          To exercise these rights, please contact us at 
          <strong>contact&#64;Mentoga.com.</strong>
        </p>

        <h5 class="text-col-pri">14. Specific Provisions for California Residents</h5>
        <p class="gilroy">
          Under the California Consumer Privacy Act (CCPA), California residents have the right to:
        </p>
        <ul class="gilroy">
          <li>
            <p class="gilroy">
              <strong>Access: </strong>
              View categories and specific pieces of collected data.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Deletion: </strong>
              Request removal of personal data.
            </p>
          </li>
          <li>
            <p class="gilroy">
              <strong>Non-Discrimination: </strong>
              Receive equal service regardless of privacy rights exercised.
            </p>
          </li>
        </ul>
        <p class="gilroy">
          Requests can be submitted to 
          <strong>contact&#64;Mentoga.com.</strong>
        </p>

        <h5 class="text-col-pri">15. Updating and Correcting Personal Information</h5>
        <p class="gilroy">
          You may update your personal information via account settings. Verification may be required
          for security purposes.
        </p>

        <h5 class="text-col-pri">16. SMS Privacy Policy</h5>
        <p class="gilroy">
          Mentoga LLC may disclose Personal Data and other information as follows:
        </p>
        <ul class="gilroy">
          <li><strong>Third Parties that Help Provide the Messaging Service: </strong>
            We will not share your opt-in to an SMS short code campaign with a third party for purposes unrelated 
            to supporting you in connection with that campaign. We may share your Personal Data with third parties 
            that help us provide the messaging service, including, but not limited to, platform providers, phone companies, 
            and other vendors who assist us in the delivery of text messages.
          </li>
          <li><strong>Additional Disclosures: </strong>
            Affiliates: We may disclose the Personal Data to our affiliates or subsidiaries; however, if we do so, 
            their use and disclosure of your Personal Data will be subject to this Policy. All the above categories 
            exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
          </li>
        </ul>

        <h5 class="text-col-pri">17. Contact Us</h5>
        <p class="gilroy">
          You may update your personal information via account settings. Verification may be required
          for security purposes.
        </p>
        <p class="gilroy">
          <strong>Email: </strong>
          contact&#64;Mentoga.com.
        </p>
        <p class="gilroy">
          Mentoga is committed to protecting your privacy and ensuring compliance with all applicable
          laws and regulations. Thank you for trusting us with your information.
        </p>
      </div>
    </div>
  </div>
</div>
